import TicketSimpleForm from './TicketSimpleForm'

export default TicketSimpleForm
